import React, { Component } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";

export default class Header extends Component {

    render() {
        const { background = "#", logo = "#" } = this.props;

        return (
            <Container fluid style={{ height: "100vh", backgroundImage: `url(${background})`, backgroundSize: "cover", backgroundAttachment: "fixed" }}>
                <Row className="h-100 d-flex align-items-center justify-content-center justify-content-lg-end">
                    <Col xs={12} lg={6} className="text-center">
                        <Image src={logo} className="img-fluid" />
                    </Col>
                </Row>
            </Container>
        );
    }
}